import React from 'react'
import TextField from './TextField'

const TextFieldRegex = ({ ...rest }) => {
  return <TextField {...rest} />
}

export default React.memo(TextFieldRegex)
